import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Card, Stack, Typography, InputAdornment } from '@mui/material';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { SettingType, SystemConfigKey } from 'src/type/settings';
import { toastError } from 'src/utils/format-error';
import * as Yup from 'yup';
import { enqueueSnackbar } from 'notistack';
import axiosInstance, { endpoints } from 'src/utils/axios';
import UpdatedText from 'src/components/ui-kit/updated-text';
import { feeSchema, getSettingValue, getSettingUpdated } from '../../utils';

const Schema = Yup.object().shape({
  // [SystemConfigKey.BUY_FEE]: feeSchema,
  // [SystemConfigKey.SELL_FEE]: feeSchema,
  [SystemConfigKey.TOPUP_FEE]: feeSchema,
  [SystemConfigKey.WITHDRAW_FEE]: feeSchema,
});

const inputs = [
  // {
  //   label: 'ค่าธรรมเนียมซื้อ',
  //   name: SystemConfigKey.BUY_FEE,
  // },
  // {
  //   label: 'ค่าธรรมเนียมขาย',
  //   name: SystemConfigKey.SELL_FEE,
  // },
  {
    label: 'ค่าธรรมเนียมเติมเงิน',
    name: SystemConfigKey.TOPUP_FEE,
  },
  {
    label: 'ค่าธรรมเนียมถอนเงิน',
    name: SystemConfigKey.WITHDRAW_FEE,
  },
];

type Props = {
  settings: SettingType[];
  forceReload: () => void;
};

export default function SettingTxFee({ settings, forceReload }: Props) {
  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(Schema),
    defaultValues: {
      // [SystemConfigKey.BUY_FEE]: getSettingValue<number>(settings, SystemConfigKey.BUY_FEE) || 0,
      // [SystemConfigKey.SELL_FEE]: getSettingValue<number>(settings, SystemConfigKey.SELL_FEE) || 0,
      [SystemConfigKey.TOPUP_FEE]:
        getSettingValue<number>(settings, SystemConfigKey.TOPUP_FEE) || 0,
      [SystemConfigKey.WITHDRAW_FEE]:
        getSettingValue<number>(settings, SystemConfigKey.WITHDRAW_FEE) || 0,
    },
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (values) => {
    try {
      const body = Object.entries(values).map(([key, value]) => ({
        key,
        value,
      }));

      await axiosInstance.post(endpoints.settings.createOrUpdate, { configs: body });
      forceReload();
      enqueueSnackbar('บันทึกสำเร็จ');
    } catch (error) {
      toastError(error);
    }
  });

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Card sx={{ py: 5, px: 3 }}>
        <Stack spacing={3}>
          <Stack>
            <Typography variant="h6">ค่าธรรมเนียมธุรกรรม</Typography>
            <Typography variant="caption" color="text.secondary">
              <UpdatedText {...getSettingUpdated(settings, SystemConfigKey.TOPUP_FEE)} />
            </Typography>
          </Stack>

          {inputs.map((input) => (
            <RHFTextField
              key={input.name}
              name={input.name}
              label={input.label}
              placeholder="0"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography fontWeight="bold" color="success.main">
                      THB
                    </Typography>
                  </InputAdornment>
                ),
              }}
            />
          ))}

          <Box>
            <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
              บันทึก
            </LoadingButton>
          </Box>
        </Stack>
      </Card>
    </FormProvider>
  );
}
